import { Baby, Brain, Scale, Speech, User, Users } from 'lucide-react';

export const FLOW_MODES = {
  regular: 'regular',
  search: 'search',
  search_facultative: 'search_facultative',
  search_patient: 'search_patient',
  edit: 'edit',
  recent_psychologist: 'recent_psychologist',
} as const;

export const AppointmentsStatus = {
  WAITING_FOR_APPOINTMENT_DATE: 'WaitingForAppointmentDatePatientDTO',
  PENDING_TO_ACCEPT_APPOINTMENT: 'PendingToAcceptAppointmentPatientDTO',
  TO_PRESENT: 'ToPresentSessionPatientDTO',
  WAITING_FOR_PSYCHO: 'WaitingForPsychoSessionDTO',
  ACCEPTED_SESSION: 'AcceptedSessionPatientDTO',
  ACCEPTED_VOICE_SESSION: 'AcceptedVoiceSessionPatientDTO',
  TO_ACCEPT_EXTENDING: 'ToAcceptExtendingSessionPatientDTO',
  TO_ACCEPT_EXTENDING_VOICE: 'ToAcceptExtendingVoiceSessionPatientDTO',
  FINISHED_SESSION: 'FinishedSessionPatientDTO',
  REPORTED_SESSION: 'ReportedSessionPatientDTO',
  CANCELED_SESSION: 'CanceledSessionPatientDTO',
  TO_PAY: 'ToPaySessionPatientDTO',
} as const;

export const AppointmentType = {
  InPerson: 'in-person',
  Video: 'video',
  Chat: 'chat',
  Voice: 'voice',
} as const;

export const APPOINTMENT_REMOTE_ID = 1;

// 24 hours in seconds
export const ONE_DAY_IN_SECONDS = 24 * 60 * 60;

export const HIDDEN_SESSION_STATUSES = new Set<string>([
  AppointmentsStatus.CANCELED_SESSION,
  AppointmentsStatus.REPORTED_SESSION,
  AppointmentsStatus.FINISHED_SESSION,
  AppointmentsStatus.TO_PAY,
]);

export const AppointmentSpeciality = {
  ADULT_PSYCHOLOGY: 1,
  COUPLES_THERAPY: 2,
  CHILD_PSYCHOLOGY: 3,
  SPEECH_THERAPY: 4,
  NEURO_PSYCHOLOGY: 5,
  FORENSIC_PSYCHIATRY_ASSESSMENT: 7,
  PAE: 11,
} as const;

export const SPECIALITY_ICONS = {
  [AppointmentSpeciality.ADULT_PSYCHOLOGY]: User,
  [AppointmentSpeciality.COUPLES_THERAPY]: Users,
  [AppointmentSpeciality.CHILD_PSYCHOLOGY]: Baby,
  [AppointmentSpeciality.NEURO_PSYCHOLOGY]: Brain,
  [AppointmentSpeciality.SPEECH_THERAPY]: Speech,
  [AppointmentSpeciality.FORENSIC_PSYCHIATRY_ASSESSMENT]: Scale,
};

export const AppointmentDuration = {
  DURATION_SINGLE: 'DURATION_SINGLE',
  DURATION_DOUBLE: 'DURATION_DOUBLE',
  DURATION_TRIPLE: 'DURATION_TRIPLE',
  DURATION_FOUR: 'DURATION_FOUR',
} as const;

export const AppointmentDurationLabels = {
  DURATION_SINGLE: '25min',
  DURATION_DOUBLE: '50min',
  DURATION_TRIPLE: '75min',
  DURATION_FOUR: '100min',
} as const;

export const AppointmentDurationInNumbers = {
  DURATION_SINGLE: 1,
  DURATION_DOUBLE: 2,
  DURATION_TRIPLE: 3,
  DURATION_FOUR: 4,
} as const;

export const SESSION_STATUS = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  CANCELED: 'canceled',
  DONE: 'done',
  COMPLETED: 'completed',
} as const;

export type SessionStatus = (typeof SESSION_STATUS)[keyof typeof SESSION_STATUS];

export const ENTERPRISE_APPOINTMENT_STATUS = {
  PENDING: 'PENDING',
  SCHEDULED: 'SCHEDULED',
  CONFIRMED: 'CONFIRMED',
  DONE: 'DONE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
